<master-detail-editor [display]="'modal'">

    <ng-container *masterDetailEditorLeftActions>
        <w-button [command]="context.displayMode === FilesDisplayMode.Picker ? toggleAddToSelectionCommand : toggleAddToDownloadsCommand" size="Medium" buttonClass="toggle-add-to-list"></w-button>
        <w-button *ngIf="!!editCommand" [command]="editCommand" size="Medium" buttonClass="toggle-add-to-list"></w-button>
    </ng-container>



    <ng-container *masterDetailEditorRightActions>

        <a (click)="movePrev()" title="Move to previous task" [ngClass]="{disabled: !canMovePrev}">
            <i class="fa-regular fa-chevron-up"></i>
        </a>

        <a (click)="moveNext()" title="Move to next task" [ngClass]="{disabled: !canMoveNext}">
            <i class="fa-regular fa-chevron-down"></i>
        </a>

        <!-- <a (click)="toggleExpand()" title="Expand" *ngIf="canExpand">
            <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center"></i>
        </a>

        <a (click)="dismiss()" title="Close" *ngIf="[FilesDisplayMode.Sidebar, FilesDisplayMode.Picker].includes(context.displayMode)">
            <i class="fa-regular fa-xmark"></i>
        </a> -->

        <a (click)="dismiss()" class="close-icon" title="Close">
            <i class="fa-regular fa-xmark"></i>
        </a>

    </ng-container>


    <div class="fieldset" *masterDetailEditorBody>

        <attachments [mode]="'Carousel'" [attachments]="attachments | call: safeAttachments" *ngIf="attachments.length > 0" [attachmentId]="attachment._id" />

    </div>

</master-detail-editor>